
import { Watch, Mixins, Component, Ref, InjectReactive, Emit } from "vue-property-decorator";

import TablePagination from "@/mixins/tablePagination";
import Resize from "@/mixins/resize";

import ETable from "@/components/ETable.vue";

import { ElForm } from "element-ui/types/form";

// 工具
import { debounce, cloneDeep } from "lodash";

import { dataStoreDetection, dataStoreDetectionCount } from "@/api/data";

import { getMerchantStoreList } from "@/api/store";

import dayjs from "dayjs";

@Component({
  components: {
      ETable,
  }
})
export default class StoreDataDetection extends Mixins(Resize, TablePagination) {
[x: string]: any;
    @Ref("addFormRef") AddFormRef!: ElForm;
    @InjectReactive() activeName!: string;
    @InjectReactive() storeTypeList!: Array<any>;
    
    queryForm = {
        times: [],
        storeType: undefined,
        merchantName: undefined,
        storeName: undefined,
        sortCol: "",
        sortType: null,
        storeShowName: ""
    }

    loading = false;
    tableData = [];

    userLoading = false;
    allMerchantList = [];

    count10001 = 0;
    count10003 = 0;
    count10004 = 0;
    count10005 = 0;
    countAll = 0;

    tabListSurplusHeight = 80;

    get columns() {
        return [
            { label: "门店类型", prop: "storeType" },
            { label: "门店名称", prop: "storeName" },
            { label: "门店外显名称", prop: "storeShowName" },
            { label: `舌诊次数（${this.count10001}）`, prop: "num10001", sortable: "custom" },
            { label: `脉诊次数（${this.count10003}）`, prop: "num10003", sortable: "custom" },
            { label: `体质辨识次数（${this.count10004}）`, prop: "num10004", sortable: "custom" },
            { label: `肺功能检测次数（${this.count10005}）`, prop: "num10005", sortable: "custom" },
            { label: `总计（${this.countAll}）`, prop: "numAll", sortable: "custom" },
        ]
    }

    mounted() {
        this.windowResize();
    }

    getMerchantList(str) {
    if (typeof str == "object") {
      str = "";
    }
    this.userLoading = true;
    getMerchantStoreList({
      name: str
    })
      .then((res) => {
        this.userLoading = false;
        const allMerchantList = res.data || [];
        this.allMerchantList = allMerchantList.map((item) => {
          item.name = item.name;
          item.id = item.id;
          return item;
        });
      })
      .catch((err) => {
        this.userLoading = false;
      });
  }

    //重置分页参数
    resetPages() {
        this.currentPage = 1;
        this.count10001 = 0;
        this.count10003 = 0;
        this.count10004 = 0;
        this.count10005 = 0;
        this.countAll = 0;
    }

    goStore(row) {
        this.$router.push({
            path: "/storeList",
            query: {
                storeName: encodeURIComponent(row.storeName),
            }
        })
    }

    handleSortChange(e) {
        console.log(e);
        const { prop, order } = e;
        const propMap = {
           "num10001": 0,
           "num10003": 1,
           "num10004": 2,
           "num10005": 3,
           "numAll": 4
        } 
        this.queryForm.sortCol = propMap[prop];
        this.queryForm.sortType = order == "ascending" ? 1 : 0;
        this.getData();
    }

    // 搜索
    handleSearch() {
        this.resetPages();
        this.getData();
    }
    

    @Watch("activeName", { immediate: true })
    getData() {
        if (this.activeName !== "first") return;
        const { times } = this.queryForm;
        const params = {
            pageNum: this.currentPage,
            pageSize: this.pageSize,
            ...this.queryForm,
            startTime: (times || [])[0] && dayjs((times || [])[0]).format("YYYY-MM-DD HH:mm:ss"),
            endTime: (times || [])[1] && dayjs((times || [])[1]).format("YYYY-MM-DD HH:mm:ss"),
        }
        this.loading = true;
        dataStoreDetection(params).then((res) => {
            const { list } = res.data;
            this.tableData = list;
            this.itemTotal = res.data.total;
            this.tableData.forEach((el) => {
                el.storeTypeDesc = this.storeTypeList.find(el2 => el2.val == el.storeType)?.name;
                // this.count10001 += el.num10001;
                // this.count10003 += el.num10003;
                // this.count10004 += el.num10004;
                // this.count10005 += el.num10005;
                // this.countAll += el.numAll;
            })
            dataStoreDetectionCount(params).then((res) => {
                const { countPef, countPhysique, countPulse, countTongue, countTotal } = res.data;
                this.count10001 = countTongue;
                this.count10003 = countPulse;
                this.count10004 = countPhysique;
                this.count10005 = countPef;
                this.countAll = countTotal;
            })
        }).finally(() => {
            this.loading = false;
        })
    }

    @Watch("storeTypeList", { deep: true })
    formatTableData() {
        if (!this.storeTypeList?.length) return;
        this.tableData.forEach((el) => {
            el.storeTypeDesc = this.storeTypeList.find(el2 => el2.val == el.storeType)?.name;
        })
    }
}
